<template>
  <div>
    <b-modal
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      ref="loyalty"
      title="Redeem Loyalty"
      @hide="hideLoyalty"
      hide-footer
    >
      <iframe
        class="pl-5 ml-4"
        :src="loyalty_url"
        height="400"
        width="750"
        frameborder="0"
        scrolling="no"
      ></iframe>
      <b-row class="float-right">
        <b-button
          class="mr-3"
          :disabled="gateway_response == ''"
          @click="savePayment"
          id="save-payment-loyalty"
          >Save</b-button
        >
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import db from "../database";
export default {
  name: "loyalty",
  props: {
    isShow: false,
    data: {},
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    // isOfflineEnabled() {
    //   let check = false;
    //   if (
    //     this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
    //     this.state.system.settings.vendor_app_menu.offline.status == 1 &&
    //     this.state.system.isOffline == false
    //   ) {
    //     check = true;
    //   }
    //   return check;
    // }
  },
  data() {
    return {
      loyalty_url: "",
      gateway_response: "",
    };
  },
  mounted() {
    window.addEventListener("message", (e) => {
      if (
        e.origin != "http://localhost:8080" &&
        e.origin != "https://app.gozwing.com"
      ) {
        if (
          (e.data.hasOwnProperty("mobileNo") && e.data.mobileNo != "") ||
          (e.data.hasOwnProperty("MOBILENO") && e.data.MOBILENO != "")
        ) {
          this.gateway_response = e.data;
        }
      }
    });
  },
  watch: {
    isShow() {
      if (this.isShow == true) {
        console.log("[LOYALTY BOX: OPEN]");
        this.$refs["loyalty"].show();
        this.loyalty_url = this.data.url;
      }
    },
  },
  methods: {
    hideLoyalty() {
      this.$emit("hide-loyalty");
    },
    savePayment() {
      this.$loading = true;
      this.hideLoyalty();
      this.$refs["loyalty"].hide();
      let order_id = "";
      if (
        this.state.system.isOffline == false &&
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1
      ) {
        // helper.getInvoiceId("invoice_id");
        order_id = this.state.billing.billing.invoice_no;
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      let postData = {
        amount:
          this.data.type == "COUPON"
            ? this.gateway_response.hasOwnProperty("redeemedvalue")
              ? this.gateway_response.redeemedvalue
              : this.gateway_response.hasOwnProperty("factor")
              ? this.gateway_response.factor
              : this.gateway_response.hasOwnProperty("FACTOR")
              ? this.gateway_response.FACTOR
              : ""
            : this.gateway_response.hasOwnProperty("redeemedValue")
            ? this.gateway_response.redeemedValue
            : this.gateway_response.hasOwnProperty("redeemedvalue")
            ? this.gateway_response.redeemedvalue
            : "",
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: this.gateway_response.hasOwnProperty("referenceNo")
          ? this.gateway_response.referenceNo
          : this.gateway_response.hasOwnProperty("referenceno")
          ? this.gateway_response.referenceno
          : this.gateway_response.hasOwnProperty("REFERENCENO")
          ? this.gateway_response.REFERENCENO
          : "",
        method: this.data.type == "LOYALTY" ? "loyalty_emr" : "coupon",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status: "success",
        address_id: "",
        payment_gateway_type: this.data.type,
        cash_collected: "",
        cash_return: "",
        lay_by_total: "",
        lay_by_remark: "",
        transaction_sub_type: "",
        url: "save-payment",
        gateway_response: JSON.stringify(this.gateway_response),
        payment_gateway_device_type: "",
        invoice_seq: order_id,
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            // if (this.isOfflineEnabled) {
            //   this.$store.dispatch("billing/saveInvoiceId");
            // }
            this.$store.commit("billing/resetBilling");
          }
          this.gateway_response = "";
        })
        .catch((err) => {
          console.log(err.response);
          this.$loading = false;
          // this.$bvModal.msgBoxOk(err.response.data.message);
        });
    },
    // comunicate() {
    //   let iframe = document.getElementById("iframe");
    //   let msg = { text: "Hola mundo" };
    //   iframe.contentWindow.postMessage(msg, "*");
    // }
  },
};
</script>
